export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_APPLICATION = process.env.REACT_APP_APPLICATION
export const REACT_APP_SECRET = process.env.REACT_APP_SECRET



